module.exports = __webpack_public_path__ + "static/ecology-c895f793eedd5896a57be18069046cdd.png";